import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getCollectionpointsStats($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionpointsStats(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        collectionpointId
        lastCollectionOrderId
        lastCollectionId
        movingAvgCollectionInterval
        daysPassed
        priorityIndex
        collectionpoint {
          id
          code
          name
          addressDescription
          addressLine1
          addressLine2
          addressArea
          addressCity
          addressNomos
          postalCode
          phone
          cpGroup {
            id
            name
          }
        }
        lastCollectionOrder {
          id
          code
          orderedDate
          collectorId
          collector {
            id
            name
          }
          collectionOrderState {
            id
            value
            name
          }
          routesLines {
            id
            routeId
            route {
              id
              code
            }
          }
        }
        lastCollection {
          id
          code
          dateCollected
        }
      }
      recordCount
    }
  }
`;
